import React from "react";
import styled from "styled-components";
import { Icon } from "../../../../concepts/resources/Icon";
import { Colors, Grid } from "../../../../ui";
import { DropButton } from "../../../../ui/DropButton";
import { Flexer } from "../../../dashboard/elements/LayoutElements";
import { LensInfo } from "../LensInfo";

const Preview = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    padding: 1rem;
    background: ${Colors.hover};
    border-radius: .5rem;
`;

const PreviewTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    color: ${Colors.text};
    font-size: 1.25rem;
`;

const PreviewInfo = styled.div`
    color: ${Colors.text};
    font-size: 1rem;
`;

export type DescribeLensViewProps = {
    lens: LensInfo,
    onAction: (action: 'edit' | 'remove') => void
};

export const DescribeLensView = ({ lens, onAction }: DescribeLensViewProps) => {

    return <Flexer flex="column" gap=".5" padding="1">
        <Preview>
            <PreviewTitle>
                <Icon size="1.5" src="deqo://icons/i8/monocle" />
                Lens Active
            </PreviewTitle>
            <PreviewInfo>
                <div>Applying {lens.type} on query</div>
            </PreviewInfo>
        </Preview>
        <Flexer color={Colors.textLight}>
            <Grid columns="auto auto" gap=".25">
                <DropButton padding=".25" overflow="0" onClick={() => onAction('edit')}>
                    <Icon size="1.25" src="deqo://icons/hero/pencil" />
                    <span>Edit Lens</span>
                </DropButton>
                <DropButton padding=".25" overflow="0" onClick={() => onAction('remove')}>
                    <Icon size="1.25" src="deqo://icons/hero/trash" />
                    <span>Remove Lens</span>
                </DropButton>
            </Grid>
        </Flexer>
    </Flexer>
};